module.exports = __webpack_public_path__ + "static/img/activity-scene-6.bb7a3ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-scene-6.jpg
// module id = nj1R
// module chunks = 10